// extracted by mini-css-extract-plugin
export default {"button":"deleteButton_button__mfeXp"};